<template>
  <div>
    <vs-prompt
      title="Select revision"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="View revision"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <vs-select v-if="documents" label="Revision" class="w-full" v-model="selectedRevision">
            <vs-select-item
              :key="index"
              :value="document.revisionNumber"
              :text="`Revision ${document.revisionNumber} (Created ${formatDate(
                document.createdAction.timestamp,
              )})`"
              v-for="(document, index) in documents"
            />
          </vs-select>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      selectedRevision: null,
      id: "",
      documents: [],
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return this.selectedRevision !== null;
    },
    revisions() {
      return this.documents ? this.documents.map(e => e.createdAction.timestamp) : [];
    },
  },
  methods: {
    show(documentWrapper) {
      this.selectedRevision = null;
      this.id = documentWrapper.id;
      this.documents = documentWrapper.documents;

      this.prompt = true;
    },
    async accept() {
      console.log("Go to revision", this.selectedRevision);
      this.$router
        .push({
          name: "crm-legaldocument-revision",
          params: { id: this.id, revision: this.selectedRevision },
        })
        .catch(e => {
          console.log("Profile lookup", e);
        });
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
